import { i18n } from "@tellescope/i18n";
import type { VitalComparisonType } from "./useVitalConfigurationForm";

export const CLASSIFICATION_OPTIONS = [
  "Target",
  "High",
  "Very High",
  "Critical High",
  "Low",
  "Very Low",
  "Critical Low",
] as const;

export type ClassificationOption = (typeof CLASSIFICATION_OPTIONS)[number];

export const getClassificationTranslations: () => Record<ClassificationOption, string> = () => ({
  Target: i18n.t("Target", { ns: "vitals" }),
  High: i18n.t("High", { ns: "vitals" }),
  "Very High": i18n.t("Very High", { ns: "vitals" }),
  "Critical High": i18n.t("Critical High", { ns: "vitals" }),
  Low: i18n.t("Low", { ns: "vitals" }),
  "Very Low": i18n.t("Very Low", { ns: "vitals" }),
  "Critical Low": i18n.t("Critical Low", { ns: "vitals" }),
});

export const COMPARISON_TYPE_OPTIONS: VitalComparisonType[] = ["Less Than", "Greater Than", "Between"];

export const getComparisonTypeTranslations: () => Record<VitalComparisonType, string> = () => ({
  "Less Than": i18n.t("Less Than", { ns: "vitals" }),
  "Greater Than": i18n.t("Greater Than", { ns: "vitals" }),
  Between: i18n.t("Between", { ns: "vitals" }),
});

export const UNIT_OPTIONS = ["DBP", "BPM", "LB", "O2 Sat%", "SBP", "mg/dL", "A1C", "L/min", "L"] as const;

export const TREND_NONE_VALUE = "none";

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const getTrendOptions: () => { label: string; value: string }[] = () => [
  { label: i18n.t("No Trend", { ns: "vitals" }), value: TREND_NONE_VALUE },
  { label: i18n.t("Within 1 day", { ns: "vitals" }), value: String(MS_PER_DAY) },
  ...Array.from({ length: 364 }, (_, i) => {
    const days = i + 2;
    return {
      label: i18n.t("Within {{days}} days", { ns: "vitals", days }),
      value: String(days * MS_PER_DAY),
    };
  }),
];
